import { TextField, Box, Typography, FormControl, OutlinedInput, Button, Stack } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectUser } from 'store/user';
import { ApiUser } from 'types';
import { PasswordPopup } from './PasswordPopup';
import { Info } from 'components';
import { isHipaaLink } from 'config/productProfile';

import styles from './LoginPannel.module.scss';

export const LoginPannel = () => {
  const { t, i18n } = useTranslation('settings');
  const isRtl = i18n.dir() === 'rtl';
  const user: ApiUser = useSelector(selectUser)!;

  const [open, setOpen] = useState<boolean>(false);
  const supportEmail = isHipaaLink ? 'support@hipaalink.net' : 'support@via3corp.com';
  const mailtoHref = `mailto:${supportEmail}?subject=Change%20email%20address%20request`;

  const handleClickOpen = (event: MouseEvent<HTMLButtonElement>): void => {
    event.currentTarget.blur();
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <Box className={styles.login_main_container}>
      <Stack className={styles.row}>
        <Stack direction='row' alignItems='center' className={styles.emailLabelRow}>
          <span className={styles.emailLabelContent}>
            {isRtl ? (
              <>
                <Info
                  children={
                    <div>
                      {t('accountSettings.contactUs')}&nbsp;
                      <a className={styles.emailTooltipHref} href={mailtoHref}>
                        {t('accountSettings.here')}
                      </a>
                      &nbsp;{t('accountSettings.toChangeYourEmail')}
                    </div>
                  }
                />
                <Typography variant='body2' className={styles.email}>
                  {t('accountSettings.email')}
                </Typography>
              </>
            ) : (
              <>
                <Typography variant='body2' className={styles.email}>
                  {t('accountSettings.email')}
                </Typography>
                <Info
                  children={
                    <div>
                      {t('accountSettings.contactUs')}&nbsp;
                      <a className={styles.emailTooltipHref} href={mailtoHref}>
                        {t('accountSettings.here')}
                      </a>
                      &nbsp;{t('accountSettings.toChangeYourEmail')}
                    </div>
                  }
                />
              </>
            )}
          </span>
        </Stack>
        <TextField size='small' className={styles.email_textField} value={user.email} disabled />
      </Stack>

      <Typography variant='body2' className={styles.inputField}>
        {t('accountSettings.password')}
      </Typography>

      <Box className={styles.flex}>
        <FormControl className={styles.fullWidth} variant='outlined'>
          <OutlinedInput
            type='text'
            value='********'
            className={styles.font12}
            inputProps={{ 'aria-label': t('accountSettings.passwordPlaceholderAria') }}
            disabled
          />
        </FormControl>
        <Button className={styles.changeButton} variant='contained' type='button' onClick={handleClickOpen}>
          {t('accountSettings.change')}
        </Button>
      </Box>

      <PasswordPopup open={open} handleClose={handleClose} />
    </Box>
  );
};
